export default __webpack_public_path__ + "static/media/project2.204d1f58.png";